import React from "react";
import { useNavigate, Link } from "react-router-dom";
import "../assets/styles1010/UpdatedWelcomePage.css";
import Blossom from "../assets/images/Blossom.webp";
import BloomPal_Logo from "../assets/images/BloomPal_MainLogo.png";
import AuthPanelSimple from "./AuthPanelSimple";

export default function UpdatedWelcomePage() {
  const navigate = useNavigate();

  return (
    <main className="wp2-root" role="main">
      <header className="wp2-header">
        <div className="wp2-logo-badge" onClick={() => navigate("/")}>
          <img src={BloomPal_Logo} alt="BloomPal" className="wp2-logo" style={{ height: "40px", width: "auto" }} loading="eager" decoding="async" />
        </div>
      </header>

      <section className="wp2-grid">
        {/* LEFT — Marketing content */}
        <div className="wp2-left">
          <div className="wp2-left-content">
            {/* Trust Badge */}
            <div className="wp2-trust-badge">
              ✨ Trusted by 1,000+ Friends
            </div>

            {/* Headline */}
            <h1 className="wp2-marketing-h1">Your Companion for Wellness.</h1>

            {/* Sub-headline (Google Required) */}
            <p className="wp2-marketing-subheadline">
              BloomPal is an AI-driven wellness platform designed to help you manage stress, track moods, and improve mindfulness.
            </p>

            {/* Blossom with Chat Bubble */}
            <div className="wp2-mascot-container">
              <div className="mascot-wrapper">
                <div className="wp2-chat-bubble">
                  Hi! I'm Blossom!
                </div>
                <img src={Blossom} alt="Blossom, your friendly guide" className="wp2-mascot" loading="eager" decoding="async" />
              </div>
            </div>
          </div>

          <div className="wp2-left-bubbles" aria-hidden>
            <span className="l-dot ld1" />
            <span className="l-dot ld2" />
            <span className="l-ring lr1" />
            <span className="l-arc la1" />
          </div>
        </div>

        <div className="wp2-right">
          <div className="wp2-card" role="region" aria-label="Log in or sign up">
            <h2 className="wp2-card-title">Log in or sign up</h2>
            <AuthPanelSimple />
          </div>
        </div>
      </section>

      <div className="wp2-right-bubbles" aria-hidden>
        <span className="rb r1" />
        <span className="rb r2" />
        <span className="rb r3" />
      </div>

      {/* Footer with Privacy Policy and Terms of Service links */}
      <footer className="wp2-footer">
        <div className="wp2-footer-content">
          <Link to="/Privacy-Policy" className="wp2-footer-link">Privacy Policy</Link>
          <span className="wp2-footer-separator">•</span>
          <Link to="/terms-of-service" className="wp2-footer-link">Terms of Service</Link>
        </div>
      </footer>
    </main>
  );
}
